import(/* webpackMode: "eager", webpackExports: ["BasketOne"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/Basket1/index.tsx");
